import * as type from "../../types/API/bomSeries";
import { IAction } from "../userMetadataReducer";

const initialState = {
  data: null,
  loading: false,
  error: null,
};

export const bomSeriesReducer = (
  state = initialState,
  action: IAction
) => {
  switch (action.type) {
    case type.GET_BOM_SERIES:
      return {
        ...state,
        loading: true,
      };
    case type.GET_BOM_SERIES_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload.responseData,
      };
    case type.GET_BOM_SERIES_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const addBOMSeriesReducer = (
  state = initialState,
  action: IAction
) => {
  switch (action.type) {
    case type.ADD_BOM_SERIES:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case type.ADD_BOM_SERIES_SUCCESS:
      return {
        error: null,
        loading: false,
        data: action.payload.responseData,
      };
    case type.ADD_BOM_SERIES_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const editBOMSeriesReducer = (
  state = initialState,
  action: IAction
) => {
  switch (action.type) {
    case type.EDIT_BOM_SERIES:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case type.EDIT_BOM_SERIES_SUCCESS:
      return {
        error: null,
        loading: false,
        data: action.payload.responseData,
      };
    case type.EDIT_BOM_SERIES_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const deleteBOMSeriesReducer = (
  state = initialState,
  action: IAction
) => {
  switch (action.type) {
    case type.DELETE_BOM_SERIES:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case type.DELETE_BOM_SERIES_SUCCESS:
      return {
        error: null,
        loading: false,
        data: action.payload.responseData,
      };
    case type.DELETE_BOM_SERIES_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const updateLastBOMNumberReducer = (
  state = initialState,
  action: IAction
) => {
  switch (action.type) {
    case type.UPDATE_LAST_BOM_NUMBER:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case type.UPDATE_LAST_BOM_NUMBER_SUCCESS:
      return {
        error: null,
        loading: false,
        data: action.payload.responseData,
      };
    case type.UPDATE_LAST_BOM_NUMBER_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const setDefaultBOMSeriesReducer = (
  state = initialState,
  action: IAction
) => {
  switch (action.type) {
    case type.SET_DEFAULT_BOM_SERIES:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case type.SET_DEFAULT_BOM_SERIES_SUCCESS:
      return {
        error: null,
        loading: false,
        data: action.payload.responseData,
      };
    case type.SET_DEFAULT_BOM_SERIES_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
}
